// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documentUploadDropzoneContainer .filepicker {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	overflow: hidden;
	background-color: transparent;
	min-height: 250px;
	border: 1px dashed var(--btn-primaryBorder-color);
	font-family: var(--font-family-base);
	border-radius: 6px;
}

.documentUploadDropzoneContainer .filepicker .dz-message {
	display: none;
}

.documentUploadDropzoneContainer .dzInputContainer .dz-hidden-input {
	z-index: -1;
}

.documentUploadDropzoneIcon {
	position: relative;
	width: 50px;
	height: 46px;
	z-index: -1;
}

.documentUploadDropzonePlaceholder {
	position: relative;
	width: 100%;
	color: var(--primary-foreground);
	margin-top: 23px;
	z-index: -1;
	padding: 0 12px;
	font-size: 18px;
	font-weight: 500;
	line-height: 24px;
}

.maxUploadSizeText {
	font-size: 14px;
	line-height: 24px;
	font-weight: 400;
	color: var(--muted-text-color);
	margin-top: 6px;
	position: relative;
	z-index: -1;
}

.documentUploadDropzoneContainer .dz-preview .dz-details .dz-filename:hover {
	overflow: hidden;
	text-overflow: ellipsis;
}

.documentUploadDropzoneContainer .filepicker.dz-started {
	flex-direction: row;
	flex-wrap: wrap;
}

.documentUploadDropzoneContainer .filepicker.dz-started .documentUploadDropzoneIcon,
.documentUploadDropzoneContainer .filepicker.dz-started .documentUploadDropzonePlaceholder,
.documentUploadDropzoneContainer .filepicker.dz-started .maxUploadSizeText {
	display: none;
}

.documentUploadDropzoneContainer .dz-preview.dz-image-preview {
	background: transparent;
}

.documentUploadDropzoneContainer .dropzone .dz-preview.dz-error .dz-error-message {
	display: none !important;
}

@media (max-width: 575px) {
	.documentUploadDropzonePlaceholder {
		font-size: 16px;
		line-height: 22px;
	}

	.documentUploadDropzoneIcon {
		width: 40px;
		height: 36px;
	}
}


/* claim damage dropzone start */


.claimDamageDropzoneContainer .filepicker {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	row-gap: 22px;
	min-height: 130px;
	font-family: var(--font-family-base);
	background-color: transparent;
	border-radius: 12px;
	padding: 12px;
	border: none;
	font-size: 18px;
	font-weight: 400;
	line-height: normal;
	border: 1px dashed var(--border-tertiary);
}

.claimDamageDropzoneContainer .filepicker .claimDamageDropzoneIcon {
	position: relative;
	width: 31px;
	height: 31px;
	z-index: -1;
}

.claimDamageDropzoneContainer .dz-hidden-input {
	z-index: -1;
}

.claimDamageDropzoneContainer .filepicker .dz-message {
	display: none;
}

.claimDamageDropzoneContainer .filepicker.dz-started .claimDamageDropzoneIcon {
	display: none;
}

.claimDamageDropzoneContainer .dz-preview.dz-image-preview {
	background: transparent;
}

.claimDamageDropzoneContainer .dz-preview .dz-details .dz-filename:hover {
	overflow: hidden;
	text-overflow: ellipsis;
}

.claimDamageDropzoneContainer .filepicker.dz-started {
	flex-direction: row;
	flex-wrap: wrap;
}

.claimDamageDropzoneContainer .dropzone .dz-preview.dz-error .dz-error-message {
	display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/documentUploadDropzone.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,gBAAgB;CAChB,6BAA6B;CAC7B,iBAAiB;CACjB,iDAAiD;CACjD,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,gCAAgC;CAChC,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,8BAA8B;CAC9B,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;;CAGC,aAAa;AACd;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;AACD;;;AAGA,gCAAgC;;;AAGhC;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;CACtB,aAAa;CACb,iBAAiB;CACjB,oCAAoC;CACpC,6BAA6B;CAC7B,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,yCAAyC;AAC1C;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,wBAAwB;AACzB","sourcesContent":[".documentUploadDropzoneContainer .filepicker {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\toverflow: hidden;\n\tbackground-color: transparent;\n\tmin-height: 250px;\n\tborder: 1px dashed var(--btn-primaryBorder-color);\n\tfont-family: var(--font-family-base);\n\tborder-radius: 6px;\n}\n\n.documentUploadDropzoneContainer .filepicker .dz-message {\n\tdisplay: none;\n}\n\n.documentUploadDropzoneContainer .dzInputContainer .dz-hidden-input {\n\tz-index: -1;\n}\n\n.documentUploadDropzoneIcon {\n\tposition: relative;\n\twidth: 50px;\n\theight: 46px;\n\tz-index: -1;\n}\n\n.documentUploadDropzonePlaceholder {\n\tposition: relative;\n\twidth: 100%;\n\tcolor: var(--primary-foreground);\n\tmargin-top: 23px;\n\tz-index: -1;\n\tpadding: 0 12px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: 24px;\n}\n\n.maxUploadSizeText {\n\tfont-size: 14px;\n\tline-height: 24px;\n\tfont-weight: 400;\n\tcolor: var(--muted-text-color);\n\tmargin-top: 6px;\n\tposition: relative;\n\tz-index: -1;\n}\n\n.documentUploadDropzoneContainer .dz-preview .dz-details .dz-filename:hover {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.documentUploadDropzoneContainer .filepicker.dz-started {\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n\n.documentUploadDropzoneContainer .filepicker.dz-started .documentUploadDropzoneIcon,\n.documentUploadDropzoneContainer .filepicker.dz-started .documentUploadDropzonePlaceholder,\n.documentUploadDropzoneContainer .filepicker.dz-started .maxUploadSizeText {\n\tdisplay: none;\n}\n\n.documentUploadDropzoneContainer .dz-preview.dz-image-preview {\n\tbackground: transparent;\n}\n\n.documentUploadDropzoneContainer .dropzone .dz-preview.dz-error .dz-error-message {\n\tdisplay: none !important;\n}\n\n@media (max-width: 575px) {\n\t.documentUploadDropzonePlaceholder {\n\t\tfont-size: 16px;\n\t\tline-height: 22px;\n\t}\n\n\t.documentUploadDropzoneIcon {\n\t\twidth: 40px;\n\t\theight: 36px;\n\t}\n}\n\n\n/* claim damage dropzone start */\n\n\n.claimDamageDropzoneContainer .filepicker {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\trow-gap: 22px;\n\tmin-height: 130px;\n\tfont-family: var(--font-family-base);\n\tbackground-color: transparent;\n\tborder-radius: 12px;\n\tpadding: 12px;\n\tborder: none;\n\tfont-size: 18px;\n\tfont-weight: 400;\n\tline-height: normal;\n\tborder: 1px dashed var(--border-tertiary);\n}\n\n.claimDamageDropzoneContainer .filepicker .claimDamageDropzoneIcon {\n\tposition: relative;\n\twidth: 31px;\n\theight: 31px;\n\tz-index: -1;\n}\n\n.claimDamageDropzoneContainer .dz-hidden-input {\n\tz-index: -1;\n}\n\n.claimDamageDropzoneContainer .filepicker .dz-message {\n\tdisplay: none;\n}\n\n.claimDamageDropzoneContainer .filepicker.dz-started .claimDamageDropzoneIcon {\n\tdisplay: none;\n}\n\n.claimDamageDropzoneContainer .dz-preview.dz-image-preview {\n\tbackground: transparent;\n}\n\n.claimDamageDropzoneContainer .dz-preview .dz-details .dz-filename:hover {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.claimDamageDropzoneContainer .filepicker.dz-started {\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n\n.claimDamageDropzoneContainer .dropzone .dz-preview.dz-error .dz-error-message {\n\tdisplay: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
